import type { CommunitySegmentRule } from "@circle-react/components/SettingsApp/Workflows/generated/WorkflowsApi.types";
import { FiltersSeparator } from "@circle-react-shared/Filter/FiltersSeparator";
import { Filter } from "./Filter";
import { useFilters } from "./useFilters";

export interface BulkEntryRuleProps {
  rules: CommunitySegmentRule["rules"];
}

export const BulkEntryRule = ({ rules }: BulkEntryRuleProps) => {
  const { filters } = useFilters(rules);

  return (
    <div className="flex flex-wrap gap-2">
      {filters.map((filter, index) => (
        <span className="inline-flex gap-2" key={filter.name}>
          <Filter {...filter} />
          {index < filters.length - 1 && <FiltersSeparator />}
        </span>
      ))}
    </div>
  );
};
